import { SubjectsMap, ActionMap } from '../server/constants';

// Internal Level start//
// Roles
export const canCreateRoleInternal = {
  action: ActionMap.CREATE,
  subject: SubjectsMap.ROLE_INTERNAL
};

export const canUpdateRoleInternal = {
  action: ActionMap.UPDATE,
  subject: SubjectsMap.ROLE_INTERNAL
};

export const canReadRoleForApplicationInternal = {
  action: ActionMap.READ,
  subject: SubjectsMap.ROLE_INTERNAL
};

export const canDeleteRoleInternal = {
  action: ActionMap.DELETE,
  subject: SubjectsMap.ROLE_INTERNAL
};

//Products

export const canReadProductsInternal = {
  action: ActionMap.READ,
  subject: SubjectsMap.PRODUCT_INTERNAL
};

export const canCreateProductInternal = {
  action: ActionMap.CREATE,
  subject: SubjectsMap.PRODUCT_INTERNAL
};

export const canUpdateProductInternal = {
  action: ActionMap.UPDATE,
  subject: SubjectsMap.PRODUCT_INTERNAL
};

export const canDeleteProductInternal = {
  action: ActionMap.DELETE,
  subject: SubjectsMap.PRODUCT_INTERNAL
};

export const canReadProductRolesInternal = {
  action: ActionMap.READ,
  subject: SubjectsMap.ROLE_INTERNAL
};

// Permissions
export const canCreateRolePermissionInternal = {
  action: ActionMap.CREATE,
  subject: SubjectsMap.PERMISSIONS_INTERNAL
};

export const canReadRolePermissionInternal = {
  action: ActionMap.READ,
  subject: SubjectsMap.PERMISSIONS_INTERNAL
};

export const canDeleteRolePermissionInternal = {
  action: ActionMap.DELETE,
  subject: SubjectsMap.PERMISSIONS_INTERNAL
};

export const canReadOrganizationsInternal = {
  action: ActionMap.READ,
  subject: SubjectsMap.ORGANIZATION_INTERNAL
};

export const canCreateApplicationInternal = {
  action: ActionMap.CREATE,
  subject: SubjectsMap.APPLICATION_INTERNAL
};

export const canReadApplicationInternal = {
  action: ActionMap.READ,
  subject: SubjectsMap.APPLICATION_INTERNAL
};

export const canUpdateApplicationInternal =  {
  action: ActionMap.UPDATE,
  subject: SubjectsMap.APPLICATION_INTERNAL
};

export const canRemoveApplicationInternal = {
  action: ActionMap.DELETE,
  subject: SubjectsMap.APPLICATION_INTERNAL
};

export const canReadAuditLogInternal = {
  action: ActionMap.READ,
  subject: SubjectsMap.AUDIT_INTERNAL
};

// Customer
export const canReadCustomerInternal = {
  action: ActionMap.READ,
  subject: SubjectsMap.CUSTOMER_INTERNAL
};

export const canDeleteCustomerInternal = {
  action: ActionMap.DELETE,
  subject: SubjectsMap.CUSTOMER_INTERNAL
};

// Hard delete customer
export const canDeleteCustomerHardDeleteInternal = {
  action: ActionMap.DELETE,
  subject: SubjectsMap.CUSTOMER_HARD_DELETE_INTERNAL
};

export const canReadCustomerLicensesInternal = {
  action: ActionMap.READ,
  subject: SubjectsMap.CUSTOMER_LICENSE_INTERNAL
};

export const canCreateCustomerInternal = {
  action: ActionMap.CREATE,
  subject: SubjectsMap.CUSTOMER_INTERNAL
};

export const canUpdateCustomerInternal = {
  action: ActionMap.UPDATE,
  subject: SubjectsMap.CUSTOMER_INTERNAL
};

export const canReadCustomerUsersInternal = {
  action: ActionMap.READ,
  subject: SubjectsMap.CUSTOMER_USERS_INTERNAL
};

export const canCreateCustomerUsersInternal = {
  action: ActionMap.CREATE,
  subject: SubjectsMap.CUSTOMER_USERS_INTERNAL
};

export const canCreateCustomerExternalUsersInternal = {
  action: ActionMap.CREATE,
  subject: SubjectsMap.CUSTOMER_EXTERNAL_USERS_INTERNAL
};

export const canDeleteCustomerExternalUsersInternal = {
  action: ActionMap.DELETE,
  subject: SubjectsMap.CUSTOMER_EXTERNAL_USERS
};

export const canReadCustomerUsersWithRolesInternal = {
  action: ActionMap.READ,
  subject: SubjectsMap.CUSTOMER_USERS_INTERNAL
};

export const canCreteCustomerUsersInternal = {
  action: ActionMap.CREATE,
  subject: SubjectsMap.CUSTOMER_USERS_INTERNAL
};

export const canUpdateCustomerUsersInternal = {
  action: ActionMap.UPDATE,
  subject: SubjectsMap.CUSTOMER_USERS_INTERNAL
};

export const canDeleteCustomerUsersInternal = {
  action: ActionMap.DELETE,
  subject: SubjectsMap.CUSTOMER_USERS_INTERNAL
};

export const canUpdateCustomerAccountManagerInternal = {
  action: ActionMap.UPDATE,
  subject: SubjectsMap.ACCOUNT_MANAGER_INTERNAL
};

export const canUpdateAccountRepresentative = {
  action: ActionMap.UPDATE,
  subject: SubjectsMap.ACCOUNT_REPRESENTATIVE_INTERNAL
};

export const canReadOliasoftUsersInternal = {
  action: ActionMap.READ,
  subject: SubjectsMap.OLIASOFT_USERS_INTERNAL,
};

// Licenses
export const canCreateLicenseInternal = {
  action: ActionMap.CREATE,
  subject: SubjectsMap.LICENSE_INTERNAL
};

export const canReadLicensesInternal = {
  action: ActionMap.READ,
  subject: SubjectsMap.LICENSE_INTERNAL
};

export const canReadLicenseInternal = {
  action: ActionMap.READ,
  subject: SubjectsMap.LICENSE_INTERNAL
};

export const canDeleteLicenseInternal = {
  action: ActionMap.DELETE,
  subject: SubjectsMap.LICENSE_INTERNAL
};

export const canUpdateLicenseInternal = {
  action: ActionMap.UPDATE,
  subject: SubjectsMap.LICENSE_INTERNAL
};

export const canReadLicenseRolesInternal = {
  action: ActionMap.READ,
  subject: SubjectsMap.LICENSE_ROLES_INTERNAL
};

export const canEditAssignedLicenseInternal = {
  action: ActionMap.UPDATE,
  subject: SubjectsMap.CUSTOMER_LICENSE_INTERNAL
};

export const canRemoveAssignedLicenseInternal = {
  action: ActionMap.DELETE,
  subject: SubjectsMap.CUSTOMER_LICENSE_INTERNAL
};

export const canAssignLicenseToCustomerInternal = {
  action: ActionMap.CREATE,
  subject: SubjectsMap.CUSTOMER_LICENSE_INTERNAL
};

export const canReadLicenseUsersInternal = {
  action: ActionMap.READ,
  subject: SubjectsMap.LICENSE_USERS_INTERNAL
};

// Identifications
export const canReadIdentificationsInternal = {
  action: ActionMap.READ,
  subject: SubjectsMap.IDENTIFICATIONS_INTERNAL
};

export const canCreateIdentificationsInternal = {
  action: ActionMap.CREATE,
  subject: SubjectsMap.IDENTIFICATIONS_INTERNAL
};

export const canRemoveIdentificationsInternal = {
  action: ActionMap.DELETE,
  subject: SubjectsMap.IDENTIFICATIONS_INTERNAL
};

export const canReadExternalIdentificationsInternal = {
  action: ActionMap.READ,
  subject: SubjectsMap.EXTERNAL_IDENTIFICATIONS_INTERNAL,
};

export const canDeleteExternalIdentificationsInternal = {
  action: ActionMap.DELETE,
  subject: SubjectsMap.EXTERNAL_IDENTIFICATIONS_INTERNAL,
};

export const canUpdateExternalIdentificationsInternal = {
  action: ActionMap.UPDATE,
  subject: SubjectsMap.EXTERNAL_IDENTIFICATIONS_INTERNAL,
};

export const canUpdateCustomerExternalIdentificationsInternal = {
  action: ActionMap.UPDATE,
  subject: SubjectsMap.CUSTOMER_EXTERNAL_IDENTIFICATIONS_INTERNAL,
};

// API KEYS
export const canReadAPIKeysInternal = {
  action: ActionMap.READ,
  subject: SubjectsMap.API_KEYS_INTERNAL,
};
export const canCreateAPIKeysInternal = {
  action: ActionMap.CREATE,
  subject: SubjectsMap.API_KEYS_INTERNAL,
};

// Logs
export const canReadLogsInternal = {
  action: ActionMap.READ,
  subject: SubjectsMap.LOGS,
};

export const canRemoveLogsInternal = {
  action: ActionMap.DELETE,
  subject: SubjectsMap.LOGS,
};

export const canAssignRoleToUserInternal = {
  action: ActionMap.CREATE,
  subject: SubjectsMap.ROLE_USER_INTERNAL
};

export const canReadIdPUserInternal = {
  action: ActionMap.READ,
  subject: SubjectsMap.IDP_USERS_INTERNAL
};

export const canCreateIdPUserInternal = {
  action: ActionMap.CREATE,
  subject: SubjectsMap.IDP_USERS_INTERNAL
};

export const canUpdateIdPUserInternal = {
  action: ActionMap.UPDATE,
  subject: SubjectsMap.IDP_USERS_INTERNAL
};

export const canDeleteIdPUserInternal = {
  action: ActionMap.DELETE,
  subject: SubjectsMap.IDP_USERS_INTERNAL
};

// Subjects
export const canReadSubjectsInternal = {
  action: ActionMap.READ,
  subject: SubjectsMap.SUBJECTS_INTERNAL
};

export const canCreateSubjectsInternal = {
  action: ActionMap.CREATE,
  subject: SubjectsMap.SUBJECTS_INTERNAL
};

export const canSynchronizeRoleInternal = {
  action: ActionMap.CREATE,
  subject: SubjectsMap.ROLE_SYNCHRONIZATION_INTERNAL
};

// Local strategy
export const canUpdateLocalStrategyInternal = {
  action: ActionMap.UPDATE,
  subject: SubjectsMap.LOCAL_STRATEGY_INTERNAL
};

//Bggm model
export const canUpdateBGGMInternal = {
  action: ActionMap.UPDATE,
  subject: SubjectsMap.ACCESS_BGGM_MODEL_INTERNAL
};

//AI feature access
export const canUpdateAIInternal = {
  action: ActionMap.UPDATE,
  subject: SubjectsMap.ACCESS_AI_FEATURES_INTERNAL
};

// MFA
export const canUpdateMFAInternal = {
  action: ActionMap.UPDATE,
  subject: SubjectsMap.MFA_INTERNAL
};

// External users creation requests
export const canReadExternalUsersRequestsInternal = {
  action: ActionMap.READ,
  subject: SubjectsMap.EXTERNAL_USERS_REQUESTS_INTERNAL,
};
export const canUpdateExternalUsersRequestsInternal = {
  action: ActionMap.UPDATE,
  subject: SubjectsMap.EXTERNAL_USERS_REQUESTS_INTERNAL,
};
export const canCreateExternalUsersRequestsInternal = {
  action: ActionMap.CREATE,
  subject: SubjectsMap.EXTERNAL_USERS_REQUESTS_INTERNAL,
};
export const canDeleteExternalUsersRequestsInternal = {
  action: ActionMap.DELETE,
  subject: SubjectsMap.EXTERNAL_USERS_REQUESTS_INTERNAL,
};

// Internal Level end//

// Customer level start//

// Users
export const canDeleteUser = {
  action: ActionMap.DELETE,
  subject: SubjectsMap.USER
};

export const canEditUser = {
  action: ActionMap.UPDATE,
  subject: SubjectsMap.USER
};

export const canGetUserByRole = {
  action: ActionMap.READ,
  subject: SubjectsMap.CUSTOMER_USERS
};

// Roles
export const canReadRoleForApplication = {
  action: ActionMap.READ,
  subject: SubjectsMap.ROLE
};

export const canReadRoleByName = {
  action: ActionMap.READ,
  subject: SubjectsMap.ROLE
};

export const canReadRoleById = {
  action: ActionMap.READ,
  subject: SubjectsMap.ROLE
};

export const canAssignRoleToUser = {
  action: ActionMap.CREATE,
  subject: SubjectsMap.ROLE_USER
};

export const canRemoveRoleFromUser = {
  action: ActionMap.DELETE,
  subject: SubjectsMap.ROLE_USER
};

export const canReadAuditLog = {
  action: ActionMap.READ,
  subject: SubjectsMap.AUDIT
};

export const canReadCustomer = {
  action: ActionMap.READ,
  subject: SubjectsMap.CUSTOMER
};

export const canReadCustomerLicenses = {
  action: ActionMap.READ,
  subject: SubjectsMap.CUSTOMER_LICENSE
};

export const canUpdateCustomer = {
  action: ActionMap.UPDATE,
  subject: SubjectsMap.CUSTOMER
};

export const canReadCustomerUsers = {
  action: ActionMap.READ,
  subject: SubjectsMap.CUSTOMER_USERS
};

export const canCreateCustomerUsers = {
  action: ActionMap.CREATE,
  subject: SubjectsMap.CUSTOMER_USERS
};

export const canCreateCustomerExternalUsers = {
  action: ActionMap.CREATE,
  subject: SubjectsMap.CUSTOMER_EXTERNAL_USERS
};

export const canDeleteCustomerExternalUsers = {
  action: ActionMap.DELETE,
  subject: SubjectsMap.CUSTOMER_EXTERNAL_USERS
};

export const canReadCustomerUsersWithRoles = {
  action: ActionMap.READ,
  subject: SubjectsMap.CUSTOMER_USERS
};

export const canCreteCustomerUsers = {
  action: ActionMap.CREATE,
  subject: SubjectsMap.CUSTOMER_USERS
};

export const canUpdateCustomerUsers = {
  action: ActionMap.UPDATE,
  subject: SubjectsMap.CUSTOMER_USERS
};

export const canDeleteCustomerUsers = {
  action: ActionMap.DELETE,
  subject: SubjectsMap.CUSTOMER_USERS
};

export const canUpdateCustomerAccountManager = {
  action: ActionMap.UPDATE,
  subject: SubjectsMap.ACCOUNT_MANAGER
};

export const canAssignLicenseToUser = {
  action: ActionMap.CREATE,
  subject: SubjectsMap.LICENSE_USERS
};

export const canRemoveLicenseFromUser = {
  action: ActionMap.DELETE,
  subject: SubjectsMap.LICENSE_USERS
};

export const canReadLicenseUsers = {
  action: ActionMap.READ,
  subject: SubjectsMap.LICENSE_USERS
};

// API KEYS
export const canReadAPIKeys = {
  action: ActionMap.READ,
  subject: SubjectsMap.API_KEYS,
};
export const canCreateAPIKeys = {
  action: ActionMap.CREATE,
  subject: SubjectsMap.API_KEYS,
};

// Stats
export const canReadStats = {
  action: ActionMap.READ,
  subject: SubjectsMap.STATISTICS,
};

// Customer level end//

// Feature flags
export const canReadFeatureFlags = {
  action: ActionMap.READ,
  subject: SubjectsMap.FEATURE_FLAGS_INTERNAL
};

export const canCreateFeatureFlagInternal = {
  action: ActionMap.CREATE,
  subject: SubjectsMap.FEATURE_FLAGS
};

export const canEditFeatureFlags = {
  action: ActionMap.UPDATE,
  subject: SubjectsMap.FEATURE_FLAGS
};

export const canDeleteFeatureFlags = {
  action: ActionMap.DELETE,
  subject: SubjectsMap.FEATURE_FLAGS
};

// Surveys
export const canReadSurveysInternal = {
  action: ActionMap.READ,
  subject: SubjectsMap.SURVEYS_INTERNAL
};

export const canCreateSurveysInternal = {
  action: ActionMap.CREATE,
  subject: SubjectsMap.SURVEYS_INTERNAL
};

export const canUpdateSurveysInternal = {
  action: ActionMap.UPDATE,
  subject: SubjectsMap.SURVEYS_INTERNAL
};

export const canDeleteSurveysInternal = {
  action: ActionMap.DELETE,
  subject: SubjectsMap.SURVEYS_INTERNAL
};

export const canCreateUserSurveyInternal = {
  action: ActionMap.CREATE,
  subject: SubjectsMap.USER_SURVEY_INTERNAL,
};

export const canDeleteUserSurveyInternal = {
  action: ActionMap.DELETE,
  subject: SubjectsMap.USER_SURVEY_INTERNAL,
};

// Questions
export const canReadQuestionsInternal = {
  action: ActionMap.READ,
  subject: SubjectsMap.QUESTIONS_INTERNAL
};

export const canCreateQuestionsInternal = {
  action: ActionMap.CREATE,
  subject: SubjectsMap.QUESTIONS_INTERNAL
};

export const canUpdateQuestionsInternal = {
  action: ActionMap.UPDATE,
  subject: SubjectsMap.QUESTIONS_INTERNAL
};

export const canDeleteQuestionsInternal = {
  action: ActionMap.DELETE,
  subject: SubjectsMap.QUESTIONS_INTERNAL
};

export const canCreateQuestionAnswersInternal = {
  action: ActionMap.CREATE,
  subject: SubjectsMap.QUESTION_ANSWER_INTERNAL
};

export const canReadSupport = {
  action: ActionMap.READ,
  subject: SubjectsMap.SUPPORT_INTERNAL
};

// Release Notes
export const canReadReleaseNotesInternal = {
  action: ActionMap.READ,
  subject: SubjectsMap.RELEASE_NOTES_INTERNAL
};

export const canCreateReleaseNotesInternal = {
  action: ActionMap.CREATE,
  subject: SubjectsMap.RELEASE_NOTES_INTERNAL
};

export const canUpdateReleaseNotesInternal = {
  action: ActionMap.UPDATE,
  subject: SubjectsMap.RELEASE_NOTES_INTERNAL
};

export const canDeleteReleaseNotesInternal = {
  action: ActionMap.DELETE,
  subject: SubjectsMap.RELEASE_NOTES_INTERNAL
};
